<div class="form-expand-wrapper">

  <div class="content">

    <ng-container *ngIf="! isSendComplete">
      <div class="title">{{formExpand.form.title ? formExpand.form.title : "フォームタイトル"}}</div>
      <div class="description" *ngIf="formExpand.form.description"><span [innerHTML]="formExpand.form.description | linky:{stripPrefix:false}"></span></div>
      
      <form [formGroup]="formGroup">
        <!-- chromeのautocomplete対策 -->
        <input name="password" type="password" style="display:none;overflow:hidden;"><!-- password autocomplete対策 -->
        <div class="form-wrapper">
          <div class="form">
            <ul formArrayName="formPropertyKeys">
              <li *ngFor="let formPropertyKeysFormGroup of formPropertyKeysFormArray.controls; let i = index" formGroupName="{{i}}" [class]="formExpand.form.formPropertyKeys[i]?.width" class="form-field">
                <div>
                  <!-- 前説明文 -->
                  <div class="before-text" *ngIf="formExpand.form.formPropertyKeys[i]?.beforeText" [innerHTML]="formExpand.form.formPropertyKeys[i]?.beforeText"></div>
                  
                  <ng-container [ngSwitch]="formExpand.form.formPropertyKeys[i]?.inputType">
                    <ng-container *ngSwitchCase="FormPropertyKey.InputTypeText">
                      <mat-form-field appearance="outline">
                        <mat-label>{{formExpand.form.formPropertyKeys[i]?.label}} <span *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                        <input matInput formControlName="value" type="text" autocomplete="off">
                        <mat-hint>
                          <ng-container *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1">必須、</ng-container>
                          {{FormPropertyKey.InputTypeTextMaxLength}}文字以内
                        </mat-hint>
                        <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                        <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'maxlength')">入力文字数が上限を超えています</mat-error>                    
                      </mat-form-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="FormPropertyKey.InputTypeTextarea">
                      <mat-form-field appearance="outline">
                        <mat-label>{{formExpand.form.formPropertyKeys[i]?.label}} <span *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                        <textarea matInput formControlName="value" autocomplete="off"></textarea>
                        <mat-hint>
                          <ng-container *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1">必須、</ng-container>
                          {{FormPropertyKey.InputTypeTextareaMaxLength}}文字以内
                        </mat-hint>
                        <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                      </mat-form-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="FormPropertyKey.InputTypeEmail">
                      <mat-form-field appearance="outline">
                        <mat-label>{{formExpand.form.formPropertyKeys[i]?.label}} <span *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                        <input matInput formControlName="value" type="text" autocomplete="off">
                        <mat-hint>
                          <ng-container *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1">必須</ng-container>
                        </mat-hint>
                        <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                        <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'email')">メールアドレスの書式が正しくありません</mat-error>
                      </mat-form-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="FormPropertyKey.InputTypeSelectDropdown">
                      <mat-form-field appearance="outline">
                        <mat-label>{{formExpand.form.formPropertyKeys[i]?.label}} <span *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1" class="required">*</span></mat-label>
                        <mat-select matNativeControl formControlName="value">
                          <mat-option *ngFor="let option of formExpand.form.formPropertyKeys[i].options" [value]="option.value">{{option.label == null ? option.value : option.label}}</mat-option>
                        </mat-select>
                        <mat-hint>
                          <ng-container *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1">必須</ng-container>
                        </mat-hint>
                        <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')">必須項目です</mat-error>
                      </mat-form-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="FormPropertyKey.InputTypeSingleCheckbox">
                      <div class="single-checkbox-field">
                        <mat-checkbox formControlName="value" color="primary">
                          {{formExpand.form.formPropertyKeys[i]?.label}}
                          <span *ngIf="formExpand.form.formPropertyKeys[i]?.required == 1" class="required">*</span>
                        </mat-checkbox>
                        <!-- <mat-error *ngIf="hasError(formPropertyKeyFormControl(i, 'value'), 'required')" class="checkbox-error">
                          必須項目です
                        </mat-error> -->
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="FormPropertyKey.InputTypeHidden">
                      <input formControlName="value" type="hidden">
                    </ng-container>
                  </ng-container>
                  
                  <!-- 後説明文 -->
                  <div class="after-text" *ngIf="formExpand.form.formPropertyKeys[i]?.afterText" [innerHTML]="formExpand.form.formPropertyKeys[i]?.afterText"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-wrapper">
          <div class="btn"></div>
          <div class="btn"><button mat-flat-button color="primary" [class.disabled]="formGroup.invalid" [class.disabled]="formGroup.invalid" (click)="done()">{{formExpand.form.sendBtnTitle}}</button></div>
          <div class="btn"></div>
        </div>
      </form>
    </ng-container>
    <ng-container *ngIf="isSendComplete">
      <div class="send-complete-wrapper">
        <div class="title">{{formExpand.form.sendCompleteTitle}}</div>
        <div class="description" *ngIf="formExpand.form.sendCompleteDescription"><span [innerHTML]="formExpand.form.sendCompleteDescription | linky:{stripPrefix:false}"></span></div>
      </div>
    </ng-container>

  </div>

</div>